module.exports = __webpack_public_path__ + "img/NSC_Laranja.a719b20a.jpg";